import { createSlice } from '@reduxjs/toolkit';
import { setToken, clear as clearRBAC } from './rbacSlice';

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Call this when the user logs in (or when you retrieve valid Okta token data)
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
    },
    // Call this when the user logs out or when the token expires
    clearCredentials: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

// Thunk to handle setting credentials and RBAC permissions
export const loginUser = (user, token) => (dispatch) => {
  dispatch(setCredentials({ user, token }));
  dispatch(setToken(token));
};

// Thunk to handle logout
export const logoutUser = () => (dispatch) => {
  dispatch(clearCredentials());
  dispatch(clearRBAC());
};

export default authSlice.reducer;
